import Input from 'components/Input';
import React from 'react';
import styles from './DateTimePicker.module.scss';
import DatePicker, {ReactDatePickerProps} from 'react-datepicker';
import {formatISO} from 'date-fns';
import 'react-datepicker/dist/react-datepicker.css';
import classNames from 'classnames';
import {StatTime} from './icons';
interface Props extends ReactDatePickerProps {
  value?: any;
  onChange: (value: any, evt: any) => void;
  showTimeSelect?: boolean;
  dateFormat?: string;
  placeholder?: string;
  // icon?: string | React.ReactElement;
  selectsRange?: any;
  customInput?: string;
  minDate?: undefined | Date;
  minTime?: undefined | Date;
  maxTime?: undefined | Date;
  disabled?: boolean;
  showIcon?: boolean;
  inputValue?: string;
}

const DateTimePicker: React.VFC<Props> = ({
  value,
  onChange,
  showTimeSelect = true,
  dateFormat = 'MM/dd/yyyy h:mm aaa',
  placeholder = 'Select Date',
  // icon = null,
  customInput,
  minDate = null,
  minTime = undefined,
  maxTime = undefined,
  disabled = false,
  wrapperClassName,
  showIcon = true,
  inputValue,
  ...props
}) => {
  return (
    <div className={classNames(styles.wrapper, wrapperClassName)}>
      <DatePicker
        showTimeSelect={showTimeSelect}
        selected={value}
        isClearable
        minDate={minDate}
        minTime={minTime}
        disabled={disabled}
        maxTime={maxTime}
        dateFormat={dateFormat}
        placeholderText={placeholder}
        wrapperClassName={styles.datePicker}
        customInput={
          <Input
            icon={showIcon ? <StatTime color="#666666" /> : null}
            size="md"
            name="date-picker"
            readOnly={disabled}
            disabled={disabled}
            value={inputValue ? inputValue : value ? formatISO(value) : ''}
            className={classNames(styles.customInput, customInput)}
          />
        }
        clearButtonClassName={styles.clearButtonClassName}
        className={styles.wrapper}
        onChange={onChange}
        {...props}
      />
    </div>
  );
};

export default DateTimePicker;
